import { ThirdPartyLogo } from "@octopusdeploy/design-system-components";
import type { IProcessResource } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import getActionLogoUrl from "~/areas/projects/components/getActionLogoUrl";
import { resolveUrl } from "~/utils/resolveUrl";
import type { ActionToggleInfo } from "./deploymentStepsWorker";
import styles from "./style.module.less";
interface ActionSummaryProps {
    process: IProcessResource;
    action: ActionToggleInfo;
    stepActionIdsToSkip?: string[];
    actionIsExcluded?: boolean;
}
const ActionSummary: React.FC<ActionSummaryProps> = (props) => {
    return (<div className={styles.logo}>
            <ThirdPartyLogo size="1.5rem" url={resolveUrl(getLogoUrl(props.action, props.process))}/>
            <span className={props.actionIsExcluded ? styles.excludedAction : undefined}>
                {isActionDisabledOrSkipped(props.action) ? (<span className={styles.skipStepPreviewTitle}>
                        {props.action.details.ActionNumber} {props.action.details.ActionName}
                    </span>) : (<span>
                        {props.action.details.ActionNumber}. {props.action.details.ActionName}
                    </span>)}
            </span>
            {props.actionIsExcluded && <span className={styles.excludedActionPostfixLabel}> (excluded)</span>}
        </div>);
    function isActionDisabledOrSkipped(action: ActionToggleInfo) {
        return (props.stepActionIdsToSkip && props.stepActionIdsToSkip.some((id) => id === action.details.ActionId)) || action.details.IsDisabled;
    }
};
ActionSummary.displayName = "ActionSummary"
export function getLogoUrl(action: ActionToggleInfo, process: IProcessResource) {
    const findAction = () => {
        for (const key of process.Steps) {
            for (const actionResource of key.Actions) {
                if (actionResource.Id === action.Id) {
                    return actionResource;
                }
            }
        }
        return null;
    };
    return getActionLogoUrl(findAction());
}
export default ActionSummary;
